import type { SearchShelfCardSection } from 'types';

const TRACKING_CLAIMED_VALUE = '1';

/** sessionStorage 利用不可時の in-memory ガード */
const trackedKeys = new Set<string>();

const authScope = (userId?: number): 'guest' | 'member' =>
  userId != null ? 'member' : 'guest';

export const getSearchPageViewTrackingKey = (userId?: number): string =>
  `search_page_view:${authScope(userId)}`;

export const getShelfTabViewTrackingKey = (
  section: SearchShelfCardSection,
  userId?: number,
): string => `shelf_tab_view:${authScope(userId)}:${section}`;

export const getShelfCardImpressionTrackingKey = (
  section: SearchShelfCardSection,
  cardId: number,
  userId?: number,
): string =>
  `search_shelf_card_impression:${authScope(userId)}:${section}:${cardId}`;

export const getShelfCardClickTrackingKey = (
  section: SearchShelfCardSection,
  cardId: number,
  userId?: number,
): string =>
  `search_shelf_card_click:${authScope(userId)}:${section}:${cardId}`;

export const getYarikanoCardImpressionTrackingKey = (
  yarikanoGirlId: number,
  userId?: number,
): string => `yarikano_card_impression:${authScope(userId)}:${yarikanoGirlId}`;

export const getYarikanoCardClickTrackingKey = (
  yarikanoGirlId: number,
  userId?: number,
): string => `yarikano_card_click:${authScope(userId)}:${yarikanoGirlId}`;

const readStoredClaim = (key: string): boolean => {
  try {
    return sessionStorage.getItem(key) != null;
  } catch {
    return false;
  }
};

const writeStoredClaim = (key: string): void => {
  try {
    sessionStorage.setItem(key, TRACKING_CLAIMED_VALUE);
  } catch {
    // Keep the in-memory guard when sessionStorage is unavailable.
  }
};

export const isTrackingClaimed = (key: string): boolean => {
  if (trackedKeys.has(key)) return true;

  if (readStoredClaim(key)) {
    trackedKeys.add(key);
    return true;
  }

  return false;
};

/**
 * タブ存続中は未送信ならスロットを確保して true を返す。
 * 送信済みなら false。
 */
export const claimTrackingSlot = (key: string): boolean => {
  if (isTrackingClaimed(key)) return false;

  trackedKeys.add(key);
  writeStoredClaim(key);
  return true;
};

/** テスト用: メモリ上の抑制状態をクリアする */
export const clearImpressionTrackingMemory = (): void => {
  trackedKeys.clear();
};
